import React from 'react';
import { Tooltip } from 'antd';

import styles from '../table/table.module.scss';
import useUserRoleInDoc from '../hooks/useUserRoleInDoc';
import roles from '../constants/roles';

const EditableItem = ({
  editText,
  itemText,
  onClick,
  record,
  allowedForAppointedWorker,
  getPopupContainer = () => document.body,
  ...props
}) => {
  const userRole = useUserRoleInDoc(record);
  // const allowEdit =
  //   (allowedForAppointedWorker && userRole === roles.APPOINTED_WORKER) ||
  //   userRole === roles.RESPONSIBLE_OR_AUTHOR;

  // if (allowEdit) {
  return (
    <Tooltip
      title={editText}
      mouseLeaveDelay={0}
      getPopupContainer={getPopupContainer}
    >
      <span
        {...props}
        className={'dspx-ref ' + styles.tdItem}
        onClick={onClick}
      >
        {itemText}
      </span>
    </Tooltip>
  );
  // } else {
  //   return <span {...props} className={styles.tdItem}>{itemText}</span>;
  // }
};
export default EditableItem;
